const Physio = () => {
  return (
    <div className="bg-[#EDF3FF] min-h-screen w-full px-4 sm:px-6 md:px-10 lg:px-24 mt-10">
      {/* Heading */}
      <p className="font-prata mt-20 text-[#185ADB] text-[28px] sm:text-[32px] md:text-[36px] fhd:text-[44px] text-center md:text-left ">
        For Physiotherapists
      </p>

      {/* Image and Quotation Section */}
      <div className="flex flex-col md:flex-row fhd:flex-row items-center md:items-center fhd:items-center gap-10 fhd:gap-0 mt-8 fhd:mt-16 fhd:px-8">
        <img
          src="/assests/physioScreen.png"
          alt="patient"
          className="w-full max-w-[608px] sm:max-w-[608px] md:max-w-[608px] lg:max-w-[608px] fhd:max-w-[900px] fhd:min-w-[900px] h-[463px] fhd:h-[600px] mx-auto md:ml-0 fhd:ml-0"
        />

        <div className="flex flex-col items-center md:items-start fhd:items-start px-4 sm:px-0 fhd:px-0 text-center md:text-left fhd:text-left fhd:-ml-32">
          <img
            src="/assests/startQuot.png"
            alt="quotation start"
            className="h-[32px] w-[32px] sm:h-[40px] sm:w-[40px] md:h-[48px] md:w-[48px] mb-4 self-start"
          />
          <p className="text-[#585858] text-[16px] sm:text-[14px] md:text-[18px] lg:text-[22px] fhd:text-[26px] leading-relaxed max-w-[450px] fhd:max-w-[500px]">
            For physiotherapists, Ceviliyar app connects you with patients in
            need of therapeutic services at home. Manage your sessions, stay
            flexible, and build a client base all from our app.
          </p>
          <img
            src="/assests/endQuot.png"
            alt="quotation end"
            className="h-[32px] w-[32px] sm:h-[40px] sm:w-[40px] md:h-[48px] md:w-[48px] self-end"
          />
        </div>
      </div>

      {/* Features Section */}
      <div className="flex flex-col items-center md:flex-row fhd:flex-row fhd:items-end justify-start md:justify-around fhd:justify-center gap-6 md:gap-4 fhd:gap-16 mt-16 fhd:mt-24 mb-8 fhd:mb-20 px-2 md:px-2 lg:px-2 fhd:px-0 mx-4 lg:mx-4 fhd:mx-0 pb-10">
        {/* Feature Card 1 */}
        <div className="bg-white rounded-[16px] p-6  max-w-[420px] md:max-w-[360px] md:h-[120px] fhd:max-w-[440px] fhd:h-[140px] w-full shadow-sm py-8 fhd:p-10 flex-shrink-0">
          <div className="flex flex-row items-start ">
            <img
              src="/assests/convinient.png"
              alt="Convenient Appointments"
              className="h-[32px] w-[32px] object-cover"
            />
            <div className="flex flex-col ml-4">
              <p className="text-[14px] lg:text-[16px] fhd:text-[18px] font-semibold text-[#0D0D2B] font-rubik mb-2">
                Customizable Schedule
              </p>
              <p className="text-[12px] lg:text-[13px] fhd:text-[16px] text-gray-600 font-rubik">
                Set your hours, and easily manage sessions.
              </p>
            </div>
          </div>
        </div>

        {/* Feature Card 2 */}
        <div className="bg-white rounded-[16px] p-2 max-w-[420px] fhd:max-w-[440px] fhd:h-[140px] w-full shadow-sm py-8 fhd:p-10 flex-shrink-0">
          <div className="flex flex-row items-start">
            <img
              src="/assests/bag.png"
              alt="Trusted Professionals"
              className="h-[32px] w-[32px] object-cover"
            />
            <div className="flex flex-col ml-4">
              <p className="text-[14px] lg:text-[16px] fhd:text-[18px] font-semibold text-[#0D0D2B] font-rubik mb-2">
                Grow Your Practice
              </p>
              <p className="text-[12px] lg:text-[13px] fhd:text-[16px] text-gray-600 font-rubik">
                Reach more patients and grow your client base.
              </p>
            </div>
          </div>
        </div>

        {/* Feature Card 3 */}
        <div className="bg-white rounded-[16px] p-2 max-w-[420px] md:max-w-[360px] md:h-[120px]  fhd:max-w-[440px] fhd:h-[140px] w-full shadow-sm py-6 fhd:p-10 flex-shrink-0">
          <div className="flex flex-row items-start">
            <img
              src="/assests/connection.png"
              alt="Easy Management"
              className="h-[32px] w-[32px] object-cover"
            />
            <div className="flex flex-col ml-4">
              <p className="text-[14px] lg:text-[16px] fhd:text-[18px] font-semibold text-[#0D0D2B] font-rubik mb-2">
                Direct Patient Connection
              </p>
              <p className="text-[12px] lg:text-[13px] fhd:text-[16px] text-gray-600 font-rubik">
                Build connections with patients who rely on in-home
                physiotherapy services.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Physio;
